import { forwardRef } from 'react';
import { combineClassNames } from '../../Utils/ClassnameUtils';
import { GWPStatusSize, GWPStatusTone } from './StatusToken.types';

export interface GWPBadgeProps extends React.ComponentPropsWithoutRef<'span'> {
	tone?: GWPStatusTone;
	size?: GWPStatusSize;
}

const GWPBadge = forwardRef<HTMLSpanElement, GWPBadgeProps>((props, ref) => {
	const { className, tone = 'neutral', size = 'sm', children, ...rest } = props;

	const badgeClassName = combineClassNames('gwp-badge', tone, size, className);

	return (
		<span ref={ref} className={badgeClassName} {...rest}>
			{children}
		</span>
	);
});

GWPBadge.displayName = 'GWPBadge';

export default GWPBadge;
